<template lang="pug">
  .shift-page
    router-view
    .preloader-gif(
      v-if="isPending"
    )
</template>
<script>

export default {
  name: "ShiftsPage",
  data() {
    return {
      isPending: true
    };
  },
  async mounted() {
    this.$root.$on("on-show-preloader", () => {
      this.isPending = true;
    });
    this.$root.$on("on-hide-preloader", () => {
      this.isPending = false;
    });
  },
  beforeDestroy() {
    this.$root.$off("onShowPreloader");
    this.$root.$off("onHidePreloader");
  }
};
</script>
